import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TierMap } from 'entity/reward/rewardTypes';
import { useGetRewardBenefits } from 'entity/reward/rewardHooks';
import { RootState } from 'reducer';
import clsx from 'clsx';
import BenefitList from './BenefitList';

const TierBenefitCard = () => {
  const profile = useSelector((state: RootState) => state.profile.user);
  const tier = profile?.tier || 1;

  const [filter, setFilter] = useState('millionaire');
  const benefitList = useGetRewardBenefits();

  const filterList = [
    {
      title: 'Millionaire',
      value: 'millionaire',
    },
    {
      title: 'Billionaire',
      value: 'billionaire',
    },
    {
      title: 'Trillionaire',
      value: 'trillionaire',
    },
  ];

  useEffect(() => {
    setFilter(TierMap[tier].toLowerCase());
  }, [tier]);

  return (
    <div className="p-4 bg-white rounded w-full">
      <div className="flex flex-col gap-6 w-full">
        <p className="text-sm font-bold">My Tier Benefits</p>
        <div className="flex gap-5">
          {filterList.map(item => {
            const isSelected = item.value === filter;
            return (
              <span
                key={item.title}
                className={clsx(
                  'text-sm font-bold cursor-pointer',
                  isSelected ? 'text-blue-500' : 'text-neutral-500',
                )}
                onClick={() => {
                  setFilter(item.value);
                }}
                data-testid={`${item.value}-filter-button`}
              >
                {item.title}
              </span>
            );
          })}
        </div>
        <BenefitList benefits={benefitList[filter]} />
      </div>
    </div>
  );
};

export default TierBenefitCard;
